import React from "react";

function Header() {
  return (
    <header>
      <h1 className="display-1 text-center">GitHub Searcher</h1>
    </header>
  );
}

export default Header;
